import lozadInitiator from "./lozadInitiator";
import playFullscreen from "./vimeoPlayer";

const PLAY_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M8 5.33322V26.6666C7.99993 26.9038 8.06317 27.1368 8.18318 27.3414C8.30318 27.5461 8.47562 27.715 8.6827 27.8307C8.88978 27.9465 9.12399 28.0049 9.36118 28C9.59837 27.995 9.82994 27.9269 10.032 27.8026L27.3653 17.1359C27.5595 17.0166 27.7198 16.8495 27.831 16.6507C27.9422 16.4518 28.0006 16.2277 28.0006 15.9999C28.0006 15.772 27.9422 15.548 27.831 15.3491C27.7198 15.1502 27.5595 14.9832 27.3653 14.8639L10.032 4.19722C9.82994 4.07291 9.59837 4.00476 9.36118 3.9998C9.12399 3.99485 8.88978 4.05327 8.6827 4.16904C8.47562 4.2848 8.30318 4.45372 8.18318 4.65837C8.06317 4.86302 7.99993 5.09598 8 5.33322Z" fill="#7248BD"/></svg>';

const modals = {
    init() {
        document.querySelectorAll('a[href*="#subscribe"]').forEach((subscribeAnchor) => {
            subscribeAnchor.onclick = (e) => {
                e.preventDefault();
                document.getElementById('subscribe').classList.add('active');
            };
        });

        document.querySelectorAll('a[href*="#contact-person"]').forEach((subscribeAnchor) => {
            subscribeAnchor.onclick = (e) => {
                e.preventDefault();
                const modal = document.getElementById('contact-person');

                const card = subscribeAnchor.parentNode.parentNode;

                if (card.classList.contains('person-card')) {
                    const name = card.querySelector('h3').innerText;
                    const profileImage = card.querySelector('.bg-img.normal').style.backgroundImage;

                    modal.querySelector('h2 span').innerText = name;
                    modal.querySelector('input[name=website_email___person_s_name]').value = name;
                    modal.querySelector('.profile-image').style.backgroundImage = profileImage;
                } else {
                    const name = document.querySelector('h1').innerText;
                    const profileImage = document.querySelector('.page-banner--people').style.backgroundImage;

                    modal.querySelector('h2 span').innerText = name;
                    modal.querySelector('input[name=website_email___person_s_name]').value = name;
                    modal.querySelector('.profile-image').style.backgroundImage = profileImage;
                }

                modal.classList.add('active');
            };
        });

        const needHelpModal = document.getElementById('need-help');

        if (needHelpModal) {
            const question1 = needHelpModal.querySelector('#question-1');
            const question1Buttons = question1.querySelectorAll('button');
            const question2 = needHelpModal.querySelector('#question-2');
            const question2Buttons = question2.querySelectorAll('button');
            const question3 = needHelpModal.querySelector('#question-3');
            const question4 = needHelpModal.querySelector('#question-4');
            const needHelpClose = needHelpModal.getElementsByClassName('close')[0];
            const needHelpReset = needHelpModal.getElementsByClassName('js-reset')[0];

            document.querySelectorAll('a[href*="#need-help"]').forEach((subscribeAnchor) => {
                subscribeAnchor.onclick = (e) => {
                    e.preventDefault();
                    needHelpModal.classList.add('active');
                };
            });

            [needHelpReset, needHelpClose].forEach((item) => {
                item.addEventListener('click', () => {
                    resetQuestions({ initial: question1, questions: [question2, question3, question4], buttons: [question3, question4], asset_owners: [question2], reset: needHelpReset});
                    buttonAbility(question2Buttons, false);
                });
            })
            
            question1Buttons.forEach((question1Button) => {
                question1Button.addEventListener('click', () => {
                    const expertiseID = question1Button.getAttribute('data-expertise');

                    question1.classList.remove('active');
                    needHelpReset.classList.add('active');
                    question2.classList.add('active');
                    question2.querySelector('.asset-owners[data-expertise="' + expertiseID + '"]').classList.add('active');
                });
            });

            question2Buttons.forEach((question2Button) => {
                question2Button.addEventListener('click', () => {
                    const expertiseID = question2Button.getAttribute('data-expertise');

                    buttonAbility(question2Buttons, true);

                    fetch(cdScriptsObj.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Cache-Control': 'no-cache',
                        },
                        body: new URLSearchParams({
                            action: 'needHelpQuery',
                            expertiseID: JSON.stringify(expertiseID),
                        }),
                    }).then((response) => {
                        response.json().then((results) => {
                            question2.classList.remove('active');
                            question3.classList.add('active');

                            question3.querySelector('.buttons').innerHTML = results.buttons;

                            questionButtons(needHelpModal, '#question-3', question3, question4);
                        });
                    }).catch((err) => console.error(err));
                });
            });
        }

        document.querySelectorAll('a[href*="#angle-episode-info"]').forEach((infoOpener) => {
            infoOpener.onclick = (e) => {
                e.preventDefault();

                const modal = document.getElementById('angle-episode-info');
                const dataScript = infoOpener.querySelector('.js-angle-episode-data');

                if (!modal || !dataScript) {
                    return;
                }

                let data;

                try {
                    data = JSON.parse(dataScript.textContent);
                } catch (err) {
                    return;
                }

                modal.querySelector('.date').innerText = data.date || '';
                modal.querySelector('.episode-title').innerText = data.title || '';
                modal.querySelector('.teaser').innerText = data.teaser || '';
                modal.querySelector('.description').innerHTML = data.description || '';

                const bgImg = modal.querySelector('.bg-img');
                bgImg.innerHTML = (data.thumbnail || '') + '<span class="embed-play-icon play-episode" data-url="' + (data.vimeoUrl || '') + '">' + PLAY_ICON_SVG + '</span>';
                lozadInitiator.init();

                const playIcon = bgImg.querySelector('.embed-play-icon');
                const playButton = modal.querySelector('.js-angle-episode-play-btn');

                const playVideo = () => {
                    if (!data.vimeoUrl) {
                        return;
                    }

                    bgImg.innerHTML = '<iframe frameborder="0" class="embed-responsive-item" src="' + data.vimeoUrl + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
                    playFullscreen(bgImg.querySelector('iframe'));
                };

                if (playIcon) {
                    playIcon.onclick = playVideo;
                }

                if (playButton) {
                    playButton.onclick = playVideo;
                }

                modal.classList.add('active');
            };
        });

        document.querySelectorAll('.modal .close').forEach((modalClose) => {
            modalClose.onclick = (e) => {
                e.preventDefault();

                const modal = modalClose.parentNode.parentNode;

                modal.classList.remove('active');

                // Embedded video iframes (e.g. the Angle episode player) keep playing with
                // sound in the background otherwise - removing the node stops it outright.
                modal.querySelectorAll('iframe').forEach((iframe) => iframe.remove());
            };
        });
    }
}

export default modals

const buttonAbility = (buttons, disabled) => {
    buttons?.forEach((button) => {
        button.disabled = disabled;
    });
}

const resetQuestions = ({ initial, questions, buttons, asset_owners, reset }) => {
    initial?.classList.add('active');
    reset.classList.remove('active');

    questions?.forEach((question) => {
        question.classList.remove('active');
    });

    buttons?.forEach((button) => {
        button.getElementsByClassName('buttons')[0].innerHTML = '';
    });

    asset_owners?.forEach((owner) => {
        Array.from(owner.getElementsByClassName('asset-owners')).forEach((el) => {
            el.classList.remove('active');
        });
    });
}

const questionButtons = (modal, question, currentQuestion, nextQuestion) => {
    const questionButtons = modal?.querySelectorAll(`${question} button`);

    questionButtons?.forEach((questionButton) => {
        questionButton.onclick = () => {
            const expertiseID = questionButton.getAttribute('data-expertise');
            const serviceCatID = questionButton.getAttribute('data-service-cat');

            buttonAbility(questionButtons, true);

            fetch(cdScriptsObj.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({
                    action: 'needHelpQuery',
                    expertiseID: JSON.stringify(expertiseID),
                    serviceCatID: JSON.stringify(serviceCatID),
                }),
            }).then((response) => {
                response.json().then((results) => {
                    currentQuestion.classList.remove('active');
                    nextQuestion.classList.add('active');

                    nextQuestion.querySelector('.buttons').innerHTML = results.buttons;
                });
            }).catch((err) => console.error(err));
        };
    });
}
